export enum EBookerLocationType {
	START = 'start',
	END = 'end',
}

export enum ELocationPurpose {
	MEET_AND_GREET = 'meet_and_greet',
	BRANCH = 'branch',
}
